import { useBoolean } from "ahooks";
import { Button, Input, Tag } from "antd";
import { ColumnsType } from "antd/lib/table";
import React, { useContext, useEffect, useState } from "react";
import { ButtonPanel } from "../../../../component/button-panel/button_panel";
import { Search } from "../../../../component/search";
import { DataTable } from "../../../../component/table";
import { DataTableStore } from "../../../../component/table/store/data_table_store";
import { Form } from "./fullgift_from";
import { fullgiftAction } from "../../action/fullgift/file_action";
import { FullgiftStore } from "../../store/fullgift/file_store";
import { FullgiftFormStoreProvider } from "../../store/fullgift/form_store";
import { TableExpand } from "../../../../component/table-expand";
import { ConfirmModal } from "../../../../component/modal";
import { Tips, TipsGroup } from "../../../../component/tips";
import { InventorySearch } from "./file_search";
import { Mask } from "../../../../component/mask";
import { defualtPageSize, Progress } from "../../../../logic/common_logic";
import { AuthLogic } from "../../../../logic/auth_logic";
import { Control, Del, Edit, See } from "../../../../component/control-column";
import img_stop from "../../../../assets/images/zz.png";
const formParams = {
  method: "Create",
  id: "",
  subId: "",
  item: null,
};

export function Fullgift(viewPower) {
  const [createState, createFunc] = useBoolean(false);
  const [searchState, searchFunc] = useBoolean(false);
  const [confirmState, confirmFunc] = useBoolean(false);

  const { state, dispatch } = useContext(FullgiftStore);
  const { state: tableState, dispatch: tableDispatch } =
    useContext(DataTableStore);
  const [] = useBoolean(false);

  const action = fullgiftAction,
    formAction = fullgiftAction;
  const [menuButton, setData] = useState([]);
  useEffect(() => {
    (async function () {
      let r = await new AuthLogic().selButton(viewPower.viewPower);
      //console.log(r)
      if (r && r.length > 0) {
        for (let i = 0; i < r.length; i++) {
          r[i] = r[i].split("_")[r[i].split("_").length - 1];
        }
      }

      setData(r);
    })();

    return () => {};
  }, []);
  const columns: ColumnsType = [
    {
      title: "操作",
      key: "1",
      dataIndex: "oddNumbers",
      align: "center",
      width: Control.width(3),
      render: Control.render(
        (v, r) =>
          menuButton.indexOf("VIEW") != -1 && (
            <See
              click={() => {
                formParams.id = r.id;
                formParams.method = "Preview";

                createFunc.setTrue();
              }}
            />
          ),
        (v, r) =>
          menuButton.indexOf("UPDATE") != -1 &&
          r.dataState == 0 && (
            <Edit
              click={() => {
                formParams.id = r.id;
                formParams.subId = r.id;
                formParams.method = "Edit";
                formParams.item = r;

                createFunc.setTrue();
              }}
            />
          ),
        (v, r) =>
          menuButton.indexOf("STOP") != -1 &&
          r.dataState != 2 && (
            <img
              src={img_stop}
              onClick={() => {
                formParams.id = r.id;
                formParams.subId = r.id;
                confirmFunc.setTrue();
              }}
            />
          )
      ),
    },
    {
      title: "活动名称",
      dataIndex: "activityName",
      key: "3",
      align: "center",
      width: 60,
    },
    {
      title: "活动类型",
      key: "4",
      align: "center",
      width: 60,
      render: (v) => <span>满减</span>,
    },
    {
      title: "活动方式",
      key: "5",
      align: "center",
      width: 80,
      render: (v) => (
        <>
          {v.activityManner == 1 && <Tag color="volcano">满额减</Tag>}
          {v.activityManner == 2 && <Tag color="success">满额加价送</Tag>}
          {v.activityManner == 3 && <Tag color="green">满量送赠品</Tag>}
        </>
      ),
    },
    {
      title: "活动起止日期",
      key: "6",
      align: "center",
      width: 160,
      render: (v) => (
        <>
          <span>{v.beginDate + "~" + v.endDate}</span>
        </>
      ),
    },
    {
      title: "活动起止时间段",
      key: "7",
      align: "center",
      width: 160,
      render: (v) => <span>{v.beginTime + "~" + v.endTime}</span>,
    },
    {
      title: "参与门店",
      dataIndex: "shopName",
      key: "7",
      align: "center",
      width: 160,
    },
    {
      title: "活动状态",
      key: "8",
      align: "center",
      width: 60,
      render: (v) => {
        return (
          <>
            <Tag
              color={
                v.dataState == 0
                  ? "geekblue"
                  : v.dataState == 1
                  ? "success"
                  : "volcano"
              }
            >
              {v.dataStateString}
            </Tag>
          </>
        );
      },
    },
    {
      title: "创建人",
      dataIndex: "addName",
      key: "8",
      align: "center",
      width: 140,
    },
    {
      title: "创建时间",
      dataIndex: "addTime",
      key: "8",
      align: "center",
      width: 140,
    },
  ];

  const onSearch = async (pageIndex) => {
    searchFunc.setFalse();
    await action.loadPage({
      pageIndex: pageIndex,
      pageSize: defualtPageSize(),
      dispatch: tableDispatch,
      search: state.search,
    });
  };

  return (
    <>
      <Search>
        <Input
          placeholder="请输入活动名称"
          maxLength={20}
          onChange={(e) =>
            action.setCondition({
              dispatch,
              key: "seacherKey",
              value: e.target.value,
            })
          }
        />
        <input type="button" value="快速查找" onClick={() => onSearch(1)} />

        <TipsGroup>
          <input
            type="button"
            value="高级查找"
            onClick={() => searchFunc.toggle()}
          />
          <Tips display={searchState} width="48rem">
            <InventorySearch onSearch={() => onSearch(1)} />
          </Tips>
          <Mask visible={searchState} onClick={() => searchFunc.setFalse()} />
        </TipsGroup>
      </Search>

      <ButtonPanel>
        {menuButton.indexOf("ADD") != -1 && (
          <Button
            onClick={() => {
              formParams.id = "";
              formParams.method = "Create";

              createFunc.setTrue();
            }}
          >
            新增活动
          </Button>
        )}
      </ButtonPanel>

      <DataTable
        columns={columns}
        action={action}
        onLoad={async () => {
          await onSearch(1);
          Progress.done();
        }}
        onChange={(pageIndex) => {
          onSearch(pageIndex);
        }}
        scroll={{ scrollToFirstRowOnChange: true, autoY: true, x: 1060 }}
        loading={tableState.loading}
      />

      {createState && (
        <FullgiftFormStoreProvider>
          <Form
            audit={true}
            close={(hasUpdate) => {
              if (hasUpdate) {
                onSearch(tableState.current);
              }

              createFunc.setFalse();
            }}
            action={formAction}
            id={formParams.id}
            subId={formParams.subId}
            item={formParams.item}
            method={formParams.method}
          />
        </FullgiftFormStoreProvider>
      )}

      <ConfirmModal
        visible={confirmState}
        title="温馨提示"
        subTitle="确认终止？"
        message="终止之后状态无法恢复，请慎重考虑"
        close={async (r) => {
          if (r) {
            await action.delRow(formParams.subId);

            onSearch(tableState.current);
          }
          confirmFunc.setFalse();
        }}
      />
    </>
  );
}
